<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>

        <v-layout :class="section === 'index' ? 'justify-space-between':'justify-end'" mb-7>
          <v-flex shrink v-if="section === 'index'">

            <v-layout>
              <v-flex pt-3 mr-4>
                ตัวชี้วัด :
              </v-flex>
              <v-flex>
                <v-text-field
                        solo
                        flat
                        v-model="keywordIndex"
                        @keyup.enter="searchIndex"
                ></v-text-field>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex shrink>
            <InputForm :type="section"></InputForm>
          </v-flex>
        </v-layout>

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>

        <v-layout v-if="section === 'index'" justify-center>

          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
                <tr>
                  <td width="5%">ลำดับ</td>
                  <td width="10%">รหัสตัวชี้วัด</td>
                  <td width="80%">ตัวชี้วัด</td>
                  <td width="5%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in indexList.data" :key="i">
                  <td>{{item.id}}.</td>
                  <td>{{item.index_code}}</td>
                  <td class="text-start">{{item.name_th}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationIndex.total > 0">
                <v-pagination v-model="paginationIndex.current"
                              :length="paginationIndex.total"
                              v-if="indexLoaded"
                              @input="onIndexPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'index-group'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
              <tr>
                <td width="10%">ลำดับ</td>
                <td width="80%">กลุ่มตัวชี้วัด</td>
                <td width="10%">แก้ไข</td>
              </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in indexGroupList.data" :key="i">
                  <td>{{item.id}}.</td>
                  <td class="text-start">{{item.name_th}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationIndexGroup.total > 0">
                <v-pagination v-model="paginationIndexGroup.current"
                              :length="paginationIndexGroup.total"
                              v-if="indexGroupLoaded"
                              @input="onIndexGroupPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>


      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import Header from '../components/Header'
  import InputForm from "../components/InputForm";
  import { mapState, mapActions } from 'vuex'
  import Service from '../services'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'index-manager',
  props: ['section'],
  components: {
    Header,
    InputForm,
    Loading
  },
  data: () => ({
    dataParam: {},
    keywordIndex: '',
    pageVisible: 8,
    indexLoaded: false,
    indexGroupLoaded: false,
    paginationIndex: {
      current: 1,
      total: 1,
      itemPerPage: 10
    },
    paginationIndexGroup: {
      current: 1,
      total: 1,
      itemPerPage: 10
    },
    sectionLoaded: true
  }),
  created() {
    this.dataParam.token = this.userData.token;
    this.onGetAllIndexPaginate(this.dataParam).then(() => {
      this.onIndexPageChange();
    });
    this.onGetAllIndexGroupPaginate(this.dataParam).then(() => {
      this.onIndexGroupPageChange();
    });

  },
  watch: {
    // re-render pagination
    section: function () {
      this.indexLoaded = false;
      this.indexGroupLoaded = false;
      setTimeout(() => {
        this.indexLoaded = true;
        this.indexGroupLoaded = true;
      }, 1);
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      indexList: state => state.index.allIndexPaginate,
      indexGroupList: state => state.index.allIndexGroupPaginate
    })
  },
  methods: {
    ...mapActions('index',['onGetAllIndexPaginate','onGetAllIndexGroupPaginate']),
    onIndexPageChange(page) {

      let data = { page: page, token: this.userData.token };

      this.paginationIndex.total = Math.ceil(this.indexList.total / this.paginationIndex.itemPerPage);

      Service.index.getAllIndexPaginate(data).then((res) => {
        this.paginationIndex.current = res.current_page;
        this.indexList.data = res.data;
        this.indexLoaded = true;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      });

    },
    onIndexGroupPageChange(page) {

      let data = { page: page, token: this.userData.token };

      this.paginationIndexGroup.total = Math.ceil(this.indexGroupList.total / this.paginationIndexGroup.itemPerPage);

      Service.index.getAllIndexGroupPaginate(data).then((res) => {
        this.paginationIndexGroup.current = res.current_page;
        this.indexGroupList.data = res.data;
        this.indexGroupLoaded = true;
      });

    },
    searchIndex () {
      let param = { keyword: this.keywordIndex, token: this.userData.token };
      this.sectionLoaded = true;

      if (param.keyword === '') {
        this.onGetAllIndexPaginate(this.dataParam).then(() => {
          this.onIndexPageChange();
        });
        return;
      }

      Service.index.searchIndex(param).then((res) => {
        this.indexList.data = res;
        this.indexLoaded = false;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })
    }

  }
}
</script>

<style scoped>

  .theme--light.v-data-table thead tr td:not(:last-child),
  .theme--light.v-data-table tbody tr td:not(:last-child) {
    border-right: solid 1px #D7D7D7 !important;
  }

</style>
